import { faArrowsUpDownLeftRight, faAnglesRight, faAnglesLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";


const ToolBoxHeading = ({ isExpanded, setIsExpanded }) => {
    return (
        <div className="editorToolbox__controls">
            <div className="editorToolbox__drag" title="Drag to move">
                <FontAwesomeIcon icon={faArrowsUpDownLeftRight} />
            </div>
            {isExpanded && (
                <div className="editorToolbox__title">
                    <p>Editor Toolbox</p>
                </div>
            )}
            <div className="editorToolbox__toggle" onClick={() => setIsExpanded(!isExpanded)}>
                <FontAwesomeIcon icon={isExpanded ? faAnglesLeft : faAnglesRight} />
            </div>
        </div>
    )
}
export default ToolBoxHeading